import React from "react";

export const TextContainer: React.FC = ({ children }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
      <div style={{ maxWidth: 990 }}>{children}</div>
    </div>
  );
};
